/* eslint-disable react-hooks/rules-of-hooks */
import { useFormDeepLayout } from '@/form/cn-form-layout';
export const mapSize = (props) => {
    const layout = { ...useFormDeepLayout() };
    return {
        ...props,
        size: props.size || layout.size || 'medium',
    };
};
